import { CommonModule } from '@angular/common';
import { Component, HostBinding, input, output } from '@angular/core';

import { UmssButtonComponent } from '../button/button.component';
import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-alert',
  standalone: true,
  imports: [CommonModule, UmssButtonComponent, UmssIconComponent],
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class UmssAlertComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}
  /** Content props */
  line1 = input<string>('');
  line2 = input<string>('');

  /** Variant props */
  type = input<'Neutral' | 'Success' | 'Error' | 'Warning' | 'Info'>('Neutral');
  variant = input<'default' | 'soft'>('default');
  showIcon = input<boolean>(true);
  flipIcon = input<boolean>(false);
  customIconName = input<string>('');

  /** Action props */
  showActionButton = input<boolean>(false);
  actionButtonLabel = input<string>('Action');
  actionButtonVariant = input<'Primary' | 'Secondary' | 'Outline' | 'Ghost'>(
    'Outline'
  );
  showCloseButton = input<boolean>(false);

  /** Layout props */
  dismissible = input<boolean>(false);
  dismissPosition = input<'top-right' | 'inline'>('inline');
  fullWidth = input<boolean>(true);
  coloredBackground = input<boolean>(false);

  /** Events */
  onClose = output<void>();
  onAction = output<MouseEvent>();

  /** Computed properties */
  get showLine2(): boolean {
    return !!this.line2();
  }

  get alertClasses(): string {
    const classes = ['refined-alert', `variant-${this.variant()}`];

    if (this.dismissible()) classes.push('dismissible');
    if (this.fullWidth()) classes.push('full-width');

    return classes.join(' ');
  }

  get iconName(): string {
    // Use custom icon if provided
    if (this.customIconName()) {
      return this.customIconName();
    }

    const icons = {
      Neutral: 'phosphorInfo',
      Success: 'phosphorCheckCircle',
      Error: 'phosphorXCircle',
      Warning: 'phosphorWarning',
      Info: 'phosphorInfo'
    };
    return icons[this.type()] || icons.Neutral;
  }

  get iconColor(): string {
    const softColors = {
      Neutral: 'var(--neutral-500)',
      Success: 'var(--emerald-500)',
      Error: 'var(--red-500)',
      Warning: 'var(--yellow-500)',
      Info: 'var(--blue-500)'
    };
    const defaultColors = {
      Neutral: 'var(--neutral-500)',
      Success: 'var(--green-500)',
      Error: 'var(--red-500)',
      Warning: 'var(--yellow-500)',
      Info: 'var(--blue-500)'
    };
    const colors = this.variant() === 'soft' ? softColors : defaultColors;
    return colors[this.type()] || colors.Neutral;
  }

  onCloseClick() {
    this.onClose.emit();
  }

  onActionClick(event: MouseEvent) {
    this.onAction.emit(event);
  }
}
